import React, { useState } from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment'

function ViewAuditReportQms() {
    const { orgcode } = useParams()
    const history = useHistory();
    const { data: auditdata, isLoading } = useQuery(
        'orgList',
        () => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + orgcode, {}))
        console.log("orgcode", auditdata)

    const handleRoute = () => {
        window.location.href="/admin/auditreportqms/" + orgcode
    }
    console.log("console")
    if (isLoading) return <h1>Loading</h1>

    return (
        <div>
             <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-body" style={{ paddingLeft: "4rem",paddingTop:"1rem",paddingRight:"6rem" }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <form>
                                            <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Name of the Organization</label>
                                                    <div className="col-sm-10">
                                                        <p>{auditdata.data.response.orgName}</p>
                                                    </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Report No</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.reportNo}</p>
                                                    </div>

                                                    <label htmlFor="staticEmail" className="col-sm-2">File No</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.fileNo}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Address</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.address}</p>
                                                    </div>

                                                    <label htmlFor="staticEmail" className="col-sm-2">Client Code</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.clientcode}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Site Address (If any)</label>
                                                    <div className="col-sm-4">
                                                        <p> NA</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-2">No.of Employees</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.effectiveNoEmpToBeAudited} </p>                                             
                                                         </div> 
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Email id</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.email}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-2">Contact Person</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.contactperson}</p>                                              
                                                         </div> 
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Telephone/Fax</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.telephone}  </p>                                          
                                                            </div>

                                                    <label htmlFor="staticEmail" className="col-sm-2">IAF Code / NACE CODE</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.iafcode}  </p>                                         
                                                        </div>
                                                </div>
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Scope</label>
                                                    <div className="col-sm-10">
                                                        <p>{auditdata.data.response.scopeofapplication}</p>
                                                    </div>
                                                    </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Non Applicable Requirements</label>
                                                    <div className="col-sm-4">
                                                        <p> {auditdata.data.response.nonapprequirements} </p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-2">Type of Audit</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.typeofaudit} </p>     
                                                   </div>
                                                </div>
                                                <div className="row mt-4">
                                                <label htmlFor="staticEmail" className="col-sm-2">Significant Changes(if any),Since last audit that affects QMS</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.significantchanges} </p>                              
                                                                       </div>
                                                    <label htmlFor="staticEmail" className="col-sm-2">Audit Team</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.auditteam}  </p>      
                                                                                               </div> 
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Date of Audit</label>
                                                    <div className="col-sm-4">
                                                        <p>{moment(auditdata.data.response.dateofaudit).format("DD-MMM-YYYY")}   </p>      
                                                                                              </div> 
                                                    <label htmlFor="staticEmail" className="col-sm-2">Place of the Audit</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.placeofaudit} </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Brief about the organization</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.briefaboutorg}   </p>      
                                                                                              </div> 
                                                    <label htmlFor="staticEmail" className="col-sm-2">Any Deviation in the Audit Plan and Reason(if any)</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.anydeviationinauditplan}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Any Significant issue impacting on the Audit Programme</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.anysignificantissue}   </p>      
                                                                                              </div> 
                                                    <label htmlFor="staticEmail" className="col-sm-2">Any unresolved issues(if identified)</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.anyunresolved}  </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Verification of effectiveness of NC / Concerns closure of Stage 1 Audit(If any)</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.verificationofeffectiveness}   </p>      
                                                                                              </div> 
                                                    <label htmlFor="staticEmail" className="col-sm-2">Criteria of Audit</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.criteriaofaudit}  </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2 mt-3">Objective of Audit</label>
                                                            <div className="col-sm-10">
                                                                <p>{auditdata.data.response.objectiveofaudit} </p>
                                                            </div>                                                   
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-2">Name of the Process</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.nameofprocess}   </p>      
                                                                                              </div> 
                                                    <label htmlFor="staticEmail" className="col-sm-2">Process Owner</label>
                                                    <div className="col-sm-4">
                                                        <p>{auditdata.data.response.processowner}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2 mt-3">Details</label>
                                                            <div className="col-sm-10">
                                                            <p  dangerouslySetInnerHTML= {{ __html: auditdata.data.response.details }}></p>
                                                                {/* <p>{auditdata.data.response.details}</p> */}
                                                            </div>                                                   
                                                </div>
                                                <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-2 mt-3">Summary</label>
                                                            <div className="col-sm-10">
                                                                <p dangerouslySetInnerHTML= {{ __html: auditdata.data.response.summary }}></p>
                                                            </div>                                                   
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button className="btn btn-primary float-right" onClick={handleRoute}>Edit</button>
                                </div>
                                
                            </div>
                            </div>
        </div>
    )
}

export default ViewAuditReportQms
